<span class="reportable-receipts-title label-medium-emphasized">
  Elenco incassi da rendicontare
</span>

<div class="reportable-receipts-desktop">
  <span class="title-medium-emphasized">Elenco incassi da rendicontare</span>

  <div class="reportable-receipts-table-container">
    <table
      mat-table
      [dataSource]="incassiDaRendicontare"
      class="reportable-receipts-table"
    >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID Incasso</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.id }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="zona">
        <th mat-header-cell *matHeaderCellDef>Zona</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.zona }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef>Cliente</th>
        <td mat-cell *matCellDef="let incasso">{{ incasso.cliente }}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="dataIncasso">
        <th mat-header-cell *matHeaderCellDef>Data incasso</th>
        <td mat-cell *matCellDef="let incasso">
          {{ incasso.dataIncasso | date:'dd/MM/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef>
          <span class="body-medium-emphasized">TOTALI</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoContanti">
        <th mat-header-cell *matHeaderCellDef>Contanti</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoContanti | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleContantiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoAssegni">
        <th mat-header-cell *matHeaderCellDef>Assegni</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoAssegni | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleAssegniSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="importoTotale">
        <th mat-header-cell *matHeaderCellDef>Totale</th>
        <td mat-cell *matCellDef="let incasso" class="currency-cell">
          {{ incasso.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="currency-cell">
          <span class="body-medium-emphasized">
            {{ totaleIncassiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="selezionato">
        <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
          <mat-checkbox
            [checked]="tuttiInclusi"
            [indeterminate]="selezioneParziale"
            aria-label="Includi tutti gli incassi"
            (change)="impostaTuttiInclusi($event.checked)"
          />
        </th>
        <td mat-cell *matCellDef="let incasso" class="checkbox-cell">
          <mat-checkbox
            [checked]="incasso.selezionato"
            [attr.aria-label]="'Includi incasso ' + incasso.id"
            (change)="impostaIncassoIncluso(incasso.id, $event.checked)"
          />
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colonneTabella"></tr>
      <tr mat-row *matRowDef="let row; columns: colonneTabella"></tr>
      <tr mat-footer-row *matFooterRowDef="colonneTabella"></tr>
    </table>
  </div>

  <div class="desktop-draft-actions">
    <button
      matButton="filled"
      type="button"
      class="desktop-action-button desktop-action-button--wide"
      *uiCan="CAPS.brogliaccioCrea"
      [disabled]="!almenoUnIncassoIncluso || isSaving"
      (click)="creaBrogliaccio()"
    >
      Crea brogliaccio
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--totals"
      disabled
    >
      Mostra totali per zona
    </button>

    <button
      matButton="outlined"
      type="button"
      class="desktop-action-button desktop-action-button--exit"
      (click)="tornaIndietro()"
    >
      Esci
    </button>
  </div>
</div>

<div class="reportable-receipts-content">
  <div class="include-all-row">
    <div class="include-all-checkbox-container">
      <mat-checkbox
        class="include-all-checkbox"
        [checked]="tuttiInclusi"
        [indeterminate]="selezioneParziale"
        (change)="impostaTuttiInclusi($event.checked)"
      >
        Includi tutti
      </mat-checkbox>
    </div>
  </div>

  <div class="reportable-receipts-list">
    @for (incasso of incassiDaRendicontare; track incasso.id) {
      <div class="reportable-receipt-card">
        <div class="reportable-receipt-data">
          <div class="receipt-checkbox-container">
            <mat-checkbox
              [checked]="incasso.selezionato"
              [attr.aria-label]="'Includi incasso ' + incasso.id"
              (change)="impostaIncassoIncluso(incasso.id, $event.checked)"
            />
          </div>
          <div class="reportable-receipt-info">
            <div class="receipt-info-first-row">
              <div class="receipt-info-pair">
                <span class="body-small">ID:</span>
                <span class="body-medium-emphasized">{{ incasso.id }}</span>
              </div>

              <div class="receipt-info-pair">
                <span class="body-small">Zona:</span>
                <span class="body-medium-emphasized">{{ incasso.zona }}</span>
              </div>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Cliente:</span>
              <span class="body-medium-emphasized">{{ incasso.cliente }}</span>
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Data incasso:</span>
              <span class="body-medium-emphasized">
                {{ incasso.dataIncasso | date:'dd/MM/yyyy' }}
              </span>
            </div>

            <div class="receipt-info-row">
              @if (incasso.importoAssegni > 0) {
                <span class="body-small">Assegni:</span>
                <span class="body-medium-emphasized">
                  {{ incasso.importoAssegni | currency:'EUR':'symbol':'1.2-2' }}
                </span>
              } @else {
                <span class="body-small">Contanti:</span>
                <span class="body-medium-emphasized">
                  {{ incasso.importoContanti | currency:'EUR':'symbol':'1.2-2' }}
                </span>
              }
            </div>

            <div class="receipt-info-row">
              <span class="body-small">Totale:</span>
              <span class="body-medium-emphasized">
                {{ incasso.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<div class="selected-receipts-summary">
  <div class="selected-receipts-summary-top">
    <div class="selected-receipts-summary-row">
      <span class="body-small">Totale contanti:</span>
      <span class="body-small-emphasized">
        {{ totaleContantiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>

    <div class="selected-receipts-summary-row">
      <span class="body-small">Totale assegni:</span>
      <span class="body-small-emphasized">
        {{ totaleAssegniSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>
  </div>

  <div class="selected-receipts-summary-divider"></div>

  <div class="selected-receipts-summary-bottom">
    <div class="selected-receipts-summary-row">
      <span class="body-large">Totale complessivo:</span>
      <span class="body-small-emphasized">
        {{ totaleIncassiSelezionati | currency:'EUR':'symbol':'1.2-2' }}
      </span>
    </div>
  </div>
</div>

<div class="new-draft-actions">
  <button
    matButton="filled"
    type="button"
    *uiCan="CAPS.brogliaccioCrea"
    [disabled]="!almenoUnIncassoIncluso || isSaving"
    (click)="creaBrogliaccio()"
  >
    Crea brogliaccio
  </button>

  <button matButton="outlined" type="button" disabled>
    Mostra totali per zona
  </button>
</div>
